// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x3OCLGp_HC {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.x3OCLGp_HC h4 {
  line-height: 3em;
}
.x3OCLGp_HC .kjFy5dp7Ol {
  float: left;
  width: 100%;
}
.x3OCLGp_HC .iAdRYChhgc {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.x3OCLGp_HC .iAdRYChhgc:hover {
  cursor: pointer;
}
.x3OCLGp_HC .iAdRYChhgc:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.wj7hKTqEv2 .ZSQOIDIsyD:focus {
  outline: none;
}
.wj7hKTqEv2 .ZSQOIDIsyD.vr417mQj4A.Urzs29NrwC {
  background: #375A88;
}
.wj7hKTqEv2 .ZSQOIDIsyD.vr417mQj4A.Urzs29NrwC span {
  color: #fff;
}
.wj7hKTqEv2 .Urzs29NrwC {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.wj7hKTqEv2 .Urzs29NrwC:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.wj7hKTqEv2 input {
  height: 38px;
  min-width: 220px;
}
.iAdRYChhgc.qIR2EqZxaD {
  background: #410102;
}
.iAdRYChhgc.k43VelewfX {
  background: #911318;
}
.iAdRYChhgc.eGgC2ofYMm {
  background: #D8293B;
}
.iAdRYChhgc.ts5Z9pZH4Y {
  background: #F2373C;
}
.iAdRYChhgc.T57yxGNPTS {
  background: #FC4448;
}
.iAdRYChhgc.l8Xu_oDvel {
  background: #ED535E;
}
.iAdRYChhgc.UQOYvos4Ix {
  background: #E34926;
}
.iAdRYChhgc.Kjill1bazq {
  background: #FC562B;
}
.iAdRYChhgc.vRqugS7hia {
  background: #FC6722;
}
.iAdRYChhgc.uSSny4NOZT {
  background: #FD7F24;
}
.iAdRYChhgc.gN0IyDR_Z8 {
  background: #FD8D26;
}
.iAdRYChhgc.sGeZqQZyMb {
  background: #EC9C3E;
}
.iAdRYChhgc.D2vYRkTz5u {
  background: #0e673a;
}
.iAdRYChhgc.yBDCGniLI3 {
  background: #208740;
}
.iAdRYChhgc.RXR7k9xLYG {
  background: #239718;
}
.iAdRYChhgc.s10Sx0okcf {
  background: #55A84D;
}
.iAdRYChhgc.EOYcEU9HD2 {
  background: #4BBE5A;
}
.iAdRYChhgc._PfjHgHwJI {
  background: #0CCA6A;
}
.iAdRYChhgc.x8lF9pQROo {
  background: #0A3C64;
}
.iAdRYChhgc.lN7DaSENRn {
  background: #0d487a;
}
.iAdRYChhgc.EiJAwCDucW {
  background: #10538d;
}
.iAdRYChhgc.kkAPqW6jUJ {
  background: #115A99;
}
.iAdRYChhgc.H_Civutj7V {
  background: #3387E2;
}
.iAdRYChhgc.sQEmyaw959 {
  background: #1BA9CF;
}
.iAdRYChhgc.znxKSqazqp {
  background: #d27c02;
}
.iAdRYChhgc.ba_xwwSkMb {
  background: #fb9402;
}
.iAdRYChhgc.PkGLXCcbR8 {
  background: #FD9B30;
}
.iAdRYChhgc.y8g13Bn9CJ {
  background: #FDBE2D;
}
.iAdRYChhgc.gU67S3NVqj {
  background: #FED831;
}
.iAdRYChhgc.MojxVAuuyJ {
  background: #FFFD38;
}
.iAdRYChhgc.sA5xt7thg2 {
  background: #2D215C;
}
.iAdRYChhgc.OvJOq6Jl9D {
  background: #483C83;
}
.iAdRYChhgc.nW18ngO4CP {
  background: #58518d;
}
.iAdRYChhgc.HL5j8IkPPr {
  background: #7068A9;
}
.iAdRYChhgc.zaWG_zL8Gs {
  background: #7f78b2;
}
.iAdRYChhgc.E6nz_uC1oQ {
  background: #8f88bc;
}
.iAdRYChhgc.Q8nfEJqN9E {
  background: #000;
}
.iAdRYChhgc.Dignc_GC4Z {
  background: #282626;
}
.iAdRYChhgc.FSl3sOMnEz {
  background: #242222;
}
.iAdRYChhgc.KJgpsV_Ppl {
  background: #353838;
}
.iAdRYChhgc.deQ0Q1Xg_3 {
  background: #666;
}
.iAdRYChhgc.qfff2AOgSU {
  background: #999;
}
.B5Q9ufJcFs {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.B5Q9ufJcFs .FoJiqpCHBf {
  display: none;
}
.zy_Wo1LtTJ {
  min-width: 670px;
}
.zy_Wo1LtTJ .DFtY7Ih7R7 .qpQOFeBhr6 {
  margin-bottom: 4px;
}
.zy_Wo1LtTJ .DFtY7Ih7R7 .qpQOFeBhr6 .aeMaK7Nxhu {
  font-size: 12px !important;
}
.zy_Wo1LtTJ .LqMVScgY4i {
  margin-top: 0px;
  background-color: transparent;
  padding: 8px 16px 8px 16px;
}
.zy_Wo1LtTJ .LqMVScgY4i .MlUrm0nOFe {
  display: block;
  font-size: 12px;
}
.zy_Wo1LtTJ .LqMVScgY4i .OV3r87fKt1 {
  height: 16px;
  min-width: 85px;
  max-width: 100% !important;
}
.zy_Wo1LtTJ .LqMVScgY4i .OV3r87fKt1 .YtlV_d2Y6k {
  font-size: 10px;
}
.zy_Wo1LtTJ .LqMVScgY4i .SdtMUioWpo {
  margin-right: 4px;
}
.zy_Wo1LtTJ .V1BkwDkxNX.V1BkwDkxNX {
  margin-left: 16px;
  margin-right: 16px;
}
.zy_Wo1LtTJ .V1BkwDkxNX.V1BkwDkxNX::after {
  content: '';
  display: block;
  border-bottom: 1px solid #fff;
  height: 1px;
  width: 100%;
  position: relative;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `x3OCLGp_HC`,
	"color-row": `kjFy5dp7Ol`,
	"color-tile": `iAdRYChhgc`,
	"picker-component": `wj7hKTqEv2`,
	"picker-element": `ZSQOIDIsyD`,
	"active": `vr417mQj4A`,
	"btn": `Urzs29NrwC`,
	"red-1": `qIR2EqZxaD`,
	"red-2": `k43VelewfX`,
	"red-3": `eGgC2ofYMm`,
	"red-4": `ts5Z9pZH4Y`,
	"red-5": `T57yxGNPTS`,
	"red-6": `l8Xu_oDvel`,
	"orange-1": `UQOYvos4Ix`,
	"orange-2": `Kjill1bazq`,
	"orange-3": `vRqugS7hia`,
	"orange-4": `uSSny4NOZT`,
	"orange-5": `gN0IyDR_Z8`,
	"orange-6": `sGeZqQZyMb`,
	"green-1": `D2vYRkTz5u`,
	"green-2": `yBDCGniLI3`,
	"green-3": `RXR7k9xLYG`,
	"green-4": `s10Sx0okcf`,
	"green-5": `EOYcEU9HD2`,
	"green-6": `_PfjHgHwJI`,
	"blue-1": `x8lF9pQROo`,
	"blue-2": `lN7DaSENRn`,
	"blue-3": `EiJAwCDucW`,
	"blue-4": `kkAPqW6jUJ`,
	"blue-5": `H_Civutj7V`,
	"blue-6": `sQEmyaw959`,
	"yellow-1": `znxKSqazqp`,
	"yellow-2": `ba_xwwSkMb`,
	"yellow-3": `PkGLXCcbR8`,
	"yellow-4": `y8g13Bn9CJ`,
	"yellow-5": `gU67S3NVqj`,
	"yellow-6": `MojxVAuuyJ`,
	"purple-1": `sA5xt7thg2`,
	"purple-2": `OvJOq6Jl9D`,
	"purple-3": `nW18ngO4CP`,
	"purple-4": `HL5j8IkPPr`,
	"purple-5": `zaWG_zL8Gs`,
	"purple-6": `E6nz_uC1oQ`,
	"black-1": `Q8nfEJqN9E`,
	"black-2": `Dignc_GC4Z`,
	"black-3": `FSl3sOMnEz`,
	"black-4": `KJgpsV_Ppl`,
	"black-5": `deQ0Q1Xg_3`,
	"black-6": `qfff2AOgSU`,
	"picker-theme": `B5Q9ufJcFs`,
	"arrow-regular": `FoJiqpCHBf`,
	"linked-tasked-list__root": `zy_Wo1LtTJ`,
	"customLinkedTasksListRoot": `DFtY7Ih7R7`,
	"customLinkedTasksListCtn": `qpQOFeBhr6`,
	"customLinkedTasksListLabel": `aeMaK7Nxhu`,
	"customLinkedTaskRoot": `LqMVScgY4i`,
	"customLinkedTaskName": `MlUrm0nOFe`,
	"customLinkedTaskChip": `OV3r87fKt1`,
	"customLinkedTaskChipLabel": `YtlV_d2Y6k`,
	"customLinkedTaskInfoIcon": `SdtMUioWpo`,
	"customLinkedTaskDivider": `V1BkwDkxNX`
};
export default ___CSS_LOADER_EXPORT___;
